
import { SearchOption } from './types';

export const searchOptions: SearchOption[] = [
  { value: 'full_name', label: 'Name' },
  { value: 'dob', label: 'Date of Birth' },
  { value: 'mobile_phone_number', label: 'Mobile Phone' },
  { value: 'home_phone_number', label: 'Home Phone' },
  { value: 'email', label: 'Email' },
  { value: 'clinic_name', label: 'Clinic Name' },
  { value: 'emr_id', label: 'EMR ID' }
];
